import { AppV1AppUserServiceDelete, AppV1AppUserServiceUpdate, AppV1AppUserResponsiblePartyServiceResetIdentity, AppV1AppUserResponsiblePartyServiceSetIdentity } from 'c1gen/permissions'
import { C1MoreButton, C1MoreButtonOptionProps } from 'components/core/button'
import { ClearIdentityModal } from 'components/pages/app/users/modals/ClearIdentityModal'
import { ResetIdentityModal } from 'components/pages/app/users/modals/ResetIdentityModal'
import { SetAccountTypeModal } from 'components/pages/app/users/modals/SetAccountTypeModal'
import { SetIdentityModal } from 'components/pages/app/users/modals/SetIdentityModal'
import { AppUserValue } from 'lib/actions/apps/app-users'
import { isC1ManagedApp } from 'lib/constants/system'
import { useSimpleModal } from 'lib/modals'
import { FC } from 'react'
import { useIntl } from 'react-intl'

export enum AppUserActionOptions {
    setAccountType,
    setIdentity,
    resetIdentity,
    clearIdentity,
}

type AppUserActionsDropdownProps = {
    appUser: AppUserValue
    options: AppUserActionOptions[]
}

export const AppUserActionsDropdown: FC<AppUserActionsDropdownProps> = ({ appUser, options: _options }) => {
    const intl = useIntl()

    const { open } = useSimpleModal()

    const options: C1MoreButtonOptionProps[] = []

    if (_options.includes(AppUserActionOptions.clearIdentity)) {
        options.push({
            label: intl.formatMessage({ id: 'component_app_users_option_clear_identity', defaultMessage: 'Clear account owner' }),
            onClick: () => open(ClearIdentityModal, { appUser })(),
            disabled: isC1ManagedApp(appUser.appId),
            permission: AppV1AppUserServiceDelete,
        })
    }

    if (_options.includes(AppUserActionOptions.resetIdentity)) {
        options.push({
            label: intl.formatMessage({ id: 'component_app_users_option_reset_identity', defaultMessage: 'Reset account owner' }),
            onClick: () => open(ResetIdentityModal, { appUser })(),
            disabled: isC1ManagedApp(appUser.appId),
            permission: AppV1AppUserResponsiblePartyServiceResetIdentity,
        })
    }

    if (_options.includes(AppUserActionOptions.setAccountType)) {
        options.push({
            label: intl.formatMessage({ id: 'component_app_users_option_set_account_type', defaultMessage: 'Set account type' }),
            onClick: () => open(SetAccountTypeModal, { appUser })(),
            permission: AppV1AppUserServiceUpdate,
        })
    }

    if (_options.includes(AppUserActionOptions.setIdentity)) {
        options.push({
            label: intl.formatMessage({ id: 'component_app_users_option_set_identity', defaultMessage: 'Set account owner' }),
            onClick: () => open(SetIdentityModal, { appUser })(),
            permission: AppV1AppUserResponsiblePartyServiceSetIdentity,
        })
    }

    return <C1MoreButton
        options={options}
        variant="outlined"
    />
}
